export default {
  themes: {
    list: [],
    main: null,
    selected: null,
    type: 'main',
    loading: false,
    visible: false,
  },
  navbarstep: 1,
};
